import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Amplify } from 'aws-amplify'
import { RouterProvider } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { router } from './routes/router.jsx'
import { ROUTE_RULES, ROUTE_SIGN_IN } from './routes/paths.js'
import { defaultStorage } from 'aws-amplify/utils'
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito'
import { AuthProvider } from './contexts/auth.context.jsx'
import { SessionTimeout } from './components/session-timeout.jsx'
import './index.css'

Amplify.configure({
  Auth: {
    Cognito: {
      loginWith: {
        oauth: {
          domain: import.meta.env.VITE_OAUTH_DOMAIN,
          scopes: import.meta.env.VITE_OAUTH_SCOPES.split(' '),
          redirectSignIn: [import.meta.env.VITE_APP_DOMAIN + ROUTE_RULES],
          redirectSignOut: [import.meta.env.VITE_APP_DOMAIN + ROUTE_SIGN_IN],
          responseType: import.meta.env.VITE_OAUTH_RESPONSE_TYPE,
        },
      },
      userPoolId: import.meta.env.VITE_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_USER_POOL_CLIENT_ID,
    },
  },
})

// Set the key-value storage for Cognito
cognitoUserPoolsTokenProvider.setKeyValueStorage(defaultStorage)

// Create a QueryClient instance
const queryClient = new QueryClient()

const root = createRoot(document.getElementById('root'))

root.render(
  <StrictMode>
    <AuthProvider>
      <QueryClientProvider client={queryClient}>
        <>
          <SessionTimeout />
          <RouterProvider router={router} />
        </>
      </QueryClientProvider>
    </AuthProvider>
  </StrictMode>
)
